import { Buffer } from 'buffer'

export default function base64ToGeoJson (base64: string): any {
  return JSON.parse(Buffer.from(base64, 'base64').toString('utf-8'))
}
